<template>
    <div class="similar-options">
        <Checkbox name="allCheckBox" class="all-check" @valueChange="allCheckHandler" :data="allCheck" v-show="isShowAllCheck" />
        <div>
            <label class="all-label" for="allCheckBox" v-show="isShowAllCheck">{{ allLabel }}</label>
            <Button class="delete-similar" @btnClick="btnClick" :text="deleteText" :icon="deleteIcon" :hoverIcon="deleteHoverIcon"></Button>
            <slot name="customBtn"></slot>
        </div>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "SimilarOptions",
    props: ["allCheck"],
    data() {
        return {
            deleteIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
            deleteHoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px"
        };
    },
    components: {
        Checkbox,
        Button
    },
    computed: {
        isShowAllCheck() {
            return true;
        },
        allLabel() {
            return this.$t("zhiji.common.selectAll");
        },
        deleteText() {
            return this.$t("zhiji.common.delete");
        }
    },
    methods: {
        allCheckHandler(data) {
            this.$emit("checkAllChange", data);
        },
        btnClick() {
            this.$emit("deleteSimilar");
        }
    }
};
</script>

<style lang="less" scoped>
.similar-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 10px 0 10px 62px;
    color: rgba(65, 71, 94, 0.7);
    border-radius: 4px 4px 0 0;
    background: #fff;
    font-size: 12px;
    cursor: pointer;

    .all-check {
        position: absolute;
        left: 24px;
    }
    .all-label {
        position: relative;
        top: -3px;
        margin-right: 15px;
    }
    .delete-similar {
        margin-right: 8px;
    }
}
</style>
